import { render, staticRenderFns } from "./imported_badge.vue?vue&type=template&id=4f1d5e78"
import script from "./imported_badge.vue?vue&type=script&lang=js"
export * from "./imported_badge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports